import {
    UPDATE_BID_PROFILE_MANAGEMENT,
    RESET_BID_PROFILE_MANAGEMENT,
    UPDATE_EMPLOYEE_BID_SELECTION,
    UPDATE_EMPLOYEE_SUBMISSION_STATUS,
} from './bidProfileManagement.actions';

/** @type {BidProfileManagement.IBidProfileManagement} */
const initialState = {
    profileId: '',
    employeesBidSelection: [],
    awardingResults: [],
    expandedRowKeys: [],
    checkedKeys: [],
    isBidOnBehalfAllowed: false,
    isEditBidOnBehalfAllowed: false,
    isRecalculateEmployeeRanksAllowed: false,
    isAwardingEmployees: false,
    rolloutErrors: [],
};

/**
 *
 * @param {BidProfileManagement.IBidProfileManagement} state
 * @param {ShiftBidding.IAction} action
 */
export default function bidProfileManagementReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_EMPLOYEE_BID_SELECTION:
            return {
                ...state,
                employeesBidSelection: [
                    ...payload,
                ],
            };
        case UPDATE_BID_PROFILE_MANAGEMENT:
            return {
                ...state,
                ...payload,
            };
        case UPDATE_EMPLOYEE_SUBMISSION_STATUS: {
            const employeeBidIndex = state.awardingResults.findIndex((x) => x.employeeId === payload.employeeId);
            state.awardingResults[employeeBidIndex] = {
                ...state.awardingResults[employeeBidIndex],
                ...payload.data,
            };
            const awardingResults = [...state.awardingResults];
            return {
                ...state,
                awardingResults,
            };
        }
        case RESET_BID_PROFILE_MANAGEMENT:
            return initialState;
        default:
            return state;
    }
}
